 
import { useMemo, useRef, useState } from "react";
import { ActionHandlerProvider } from "../Components/ActionHandlerContext";
import DynamicMaster from "../Components/DynamicMaster/DynamicMaster";
 
import { FormInstance } from "antd";
 
 
import { API } from "../Axios/Axios";

export default function CustomPage() {
  const formRef = useRef<FormInstance>(null);
   
  const [isQuickAddModalVisible, setIsQuickAddModalVisible] = useState({});
  const reportActionHandler = {
    checkIfValidationOK: async (actionType: string, ...params: any[]) => {
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    Query: async (...params: any[]) => {
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    CheckReportActionFunction: async (actionType: string, ...params: any[]) => {
      console.log("CheckReportActionFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
  };
  const rowActionHandler = {
    DynamicMasterRowView: async (...params: any[]) => {
      console.log("rowActionHandler");
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    viewClick: (...params: any[]) => {
      if (params[1].Title.includes("Har")) {
        return false;
      }
      return true;
    },
  };

  const openModalKey = useMemo(() => {
    return Object.keys(isQuickAddModalVisible).find(
      (key) => isQuickAddModalVisible[key]
    );
  }, [isQuickAddModalVisible]);

  const interfaceActionHandler = {
     
  
    handleFileSubmit: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      const formData = params[0];
      const formDataToSend = new FormData();

      formData?.UploadFiles?.forEach((file: any) => {
        formDataToSend.append("File", file.originFileObj as File);
      });

      formDataToSend.append("Overwrite", "true");
      formDataToSend.append("Container", "Demo");

      const postRes = await API.post("/Documents/upload", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Normalized structure
      const uploadedFiles =
        formData?.UploadFiles?.map((file: any) => ({
          name: postRes?.data?.data?.name ?? file.name,
          path: postRes?.data?.data?.documentUrl,
          id: postRes?.data?.data?.documentId,
        })) ?? [];

      // Update form value
      formRef.current!.setValue("UploadFiles", uploadedFiles);

      return {
        data: {
          status: 0,
          message: "OK",
          data: [
            {
              key: "UploadFiles",
              value: uploadedFiles, // full array instead of just paths
              Id: 0,
              IsActive: false,
            },
          ],
        },
      };
    },

    // Update existing + new files
    handleFileUpdate: async (actionType: string, ...params: any[]) => {
      const uploadFiles = params[0]?.UploadFiles ??  [];

      const normalizedFiles: any[] = [];

      for (const file of uploadFiles) {
        // Already uploaded file
        if (file.url && !file.originFileObj) {
          normalizedFiles.push({
            name: file.name ?? file.url.split("/").pop(),
            path: file.url.startsWith("/") ? file.url.substring(1) : file.url,
            id: file.id ? String(file.id) : "",
          });
        }
        // New file -> upload via API
        else if (file.originFileObj) {
          const formData = new FormData();
          formData.append("File", file.originFileObj);
          formData.append("overwrite", "true");
          formData.append("container", "Demo");

          try {
            const response = await API.post("/Documents/upload", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            const uploadedPath = response?.data?.data?.documentUrl ?? "";
            const uploadedId = response?.data?.data?.documentId ?? "";
            const uploadedName = response?.data?.data?.name ?? file.name;

            normalizedFiles.push({
              name: uploadedName,
              path: uploadedPath,
              id: String(uploadedId),
            });
          } catch (err) {
            console.error("Upload failed:", err);
          }
        }
      }

      // Update form value
      formRef.current!.setValue("UploadFiles", normalizedFiles);

      return {
        data: {
          status: 0,
          message: "OK",
          data: [
            {
              key: "UploadFiles",
              value: normalizedFiles,
            },
          ],
        },
      };
    },
    handleEndFunction: async (actionType: string, ...params: any[]) => {
      console.log("handleEndFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
    },
    Query: async (...params: any[]) => {
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    closeModal: async (button: any, form: any) => {
      if (openModalKey) {
       








        formRef.current!.setValue(openModalKey, form[openModalKey]);
        setIsQuickAddModalVisible((prev) => ({
          ...prev,
          [openModalKey]: false,
        }));
      }
    },
  };

  const [masked, setMasked] = useState<{ [key: string]: boolean }>({}); // NOSONAR : ignore
  const interfaceFieldActionHandler = {
    SetStateSingleValue: async (form: any) => {
      let formData = form.getFieldsValue();
      console.log(formData);
    },
    showQuickAddModal: async (form: any, label: string) => {
      if (label) {
        setIsQuickAddModalVisible((prev) => ({ ...prev, [label]: true }));
        return true;
      }
    },
      
  };

  return (
    
      <ActionHandlerProvider
        rowActionHandler={rowActionHandler}
        reportActionHandler={reportActionHandler}
        interfaceActionHandler={interfaceActionHandler}
        interfaceFieldActionHandler={interfaceFieldActionHandler}
      >
        
        <DynamicMaster
          InterfaceName={"State Master"}
          DashboardName={"State Dashboard"}
          ref={formRef}
          resetMaskedState={(v) => {
            if (v) {
              setMasked({});
            }
          }}
        />
    
      </ActionHandlerProvider>
    
  );
}
